import {Component} from '@angular/core';

@Component({
    selector: 'app-footer',
    template: `
        <div class="layout-footer clearfix">
            <img src="assets/layout/images/logo-gray.png">
            <div class="layout-footer-right">
                <a href="https://www.facebook.com/YogaLichtquelle"><i class="pi pi-facebook"></i></a>
            </div>
        </div>
    `
})
export class AppFooterComponent {

}
